<template>
  <div class="wh100">
    <div class="title_midd">污水处理厂信息</div>
    <div class="c-search-table beauty-Scroll" v-if="sewageData.length > 0">
      <el-scrollbar>
        <!-- <div class="alarm-box">
      <scrollList
        :class-option="{ step: 0.5 }"
        :data="sewageData"
        class="wh100"
        style="overflow: hidden"
        v-if="sewageData.length > 0"
      > -->
        <ul>
          <li
            v-for="(item, index) in sewageData"
            :key="'sewageList' + index"
            @click=""
          >
            <div
              class="alarm-container"
              @click="FlyStation(item.Lat, item.Lon)"
            >
              <div class="base-info">
                <div>
                  <img src="../../../assets/map/tab_9.png" />
                  <span>{{ item.SewageName }}</span>
                </div>
              </div>
              <div class="alarm-info">
                <div>
                  <img src="../../../assets/map/tab_10.png" />
                  类型:
                  <span>{{ item.SewageType }}</span>
                </div>
                <div>
                  <img src="../../../assets/map/tab_10.png" />
                  建成时间：
                  <span>{{ item.CompletionTime }}年</span>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </el-scrollbar>
    </div>
    <!-- </scrollList>
      <div v-else class="wh100 empty">暂无数据</div>
    </div> -->
  </div>
</template>
<script>
import scrollList from "vue-seamless-scroll";
export default {
  components: {
    scrollList,
  },
  props: {
    sewageData: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  methods: {
    FlyStation(lat, lon) {
      if (this.$listeners["fly"]) {
        this.$emit("fly", lat, lon, 11);
      }
    },
  },
};
</script>
<style lang="less" scoped>
* {
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  -o-box-sizing: border-box;
  -ms-box-sizing: border-box;
}
ul,
li,
span,
p,
h1,
h2,
h3,
h4,
h5,
h6,
a,
dl,
dt,
dd,
input {
  padding: 0;
  margin: 0;
  list-style: none;
  text-decoration: none;
  font-weight: normal;
  font-style: normal;
  font-family: "Microsoft yahei";
}
.title_midd {
  width: 100%;
  height: 1.83vw;
  background: url(../../../assets/map/tab_12.png) no-repeat;
  background-size: 100% 100%;
  text-align: center;
  color: #fff;
  font-size: 0.9vw;
  line-height: 1.83vw;
}
.alarm-box {
  height: calc(100% - 1.83vw);
  width: 100%;
  padding: 0.5vw;
}
.alarm-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  border-bottom: 1px dashed #014d5f;
  padding: 0.5vw;
  font-size: 0.74vw;
  color: #fff;
}
.base-info {
  display: flex;
  align-items: center;
  justify-content: space-between;
  div {
    display: flex;
    align-items: center;
  }
  img {
    height: 0.8vw;
    width: 0.8vw;
    margin-right: 0.5vw;
  }
}
.time {
  float: right;
  color: rgba(255, 255, 255, 0.6);
}
.alarm-info {
  margin-top: 0.9vw;
  margin-bottom: 0.5vw;
  display: flex;
  justify-content: space-between;
  div {
    display: flex;
    align-items: center;
    img {
      height: 0.8vw;
      width: 0.8vw;
      margin-right: 0.5vw;
    }
    span {
      color: #03aaff;
    }
  }
}
.empty {
  color: gray;
  font-size: 1vw;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
}
.c-search-table {
  width: 100%;
  height: calc(~"100% - 10px"); /*这里我用了计算属性*/
}
.beauty-Scroll {
  .el-scrollbar {
    height: 100%; /*此处一定要设置高度，不然内层的计算属性不生效*/
  }
  .el-scrollbar__wrap {
    width: calc(~"100% + 17px"); /*将垂直滚动条挤到可视区域之外*/
    height: calc(~"100% + 17px"); /*将水平滚动条挤到可视区域之外*/
  }
}
</style>